import { useDialog } from 'muibox';
import { useContext, useState } from 'react';
import { SettingsContext } from '../store/SettingsContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

/**
 * Handles the handoff to the v2 Messaging app: calls the authenticated v1 endpoint (which provisions the
 * v2 user + maps pages + mints a single-use token) and redirects the browser to the returned v2 URL.
 */
const useMessagingHandoff = () => {
    const settingsContext = useContext(SettingsContext);
    const axios = useAxios();
    const dialog = useDialog();

    const [isHandingOff, setIsHandingOff] = useState<boolean>(false);

    const goToMessaging = async (): Promise<void> => {
        setIsHandingOff(true);

        const query: string = `${settingsContext.routes.messaging.base}handoff`;

        const url: string | null = await axios
            .get(query)
            .then(response => response.data?.url ?? null)
            .catch(error => {
                console.error(error);
                handleHttpError(error, dialog);

                return null;
            });

        setIsHandingOff(false);

        if (url) {
            // Same-tab redirect "passes the user over" to v2 (the token is single-use and short-lived).
            window.location.assign(url);
        }
    };

    return { goToMessaging, isHandingOff };
};

export default useMessagingHandoff;
